"use client";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="flex min-h-screen items-center justify-center px-5 py-16">
      <div className="sketch-panel max-w-lg rotate-[0.4deg] p-8 text-center">
        <p className="font-marker text-6xl leading-none">Prasklo to</p>
        <h1 className="mt-2 font-marker text-3xl">Papír se někde zohýbal</h1>
        <p className="mt-2 text-ink-soft">
          Něco se pokazilo při kreslení scény. Zkuste ji složit znovu.
        </p>
        {error.digest ? (
          <p className="mt-2 text-xs uppercase tracking-widest text-ink-faint">
            kód poruchy: {error.digest}
          </p>
        ) : null}
        <button type="button" onClick={reset} className="sketch-button sketch-button-primary mt-6">
          Zkusit znovu
        </button>
      </div>
    </main>
  );
}
